/* -----------------Globals--------------- */
import { useTranslation } from "react-i18next";
import { ActivityIndicator } from "react-native-paper";

/* -----------------Child components--------------- */
import Box from "../Box";
import EmptyView from "../EmptyView";
import { ChatList } from "./ChatList";

/* -----------------Types--------------- */
import type { MessagesViewProps } from "./types/props";

import { defaultAiAssistantInfo } from "@memorang/helpers/constants";
/* -----------------Helpers & Hooks--------------- */
import { ailaEmptyStateImg } from "./constants";

export const MessagesView = ({
	messages,
	messageActions,
	isRecommendedQuestionsFetching,
	loading,
	streaming,
	recommendedQueries = [],
	handleSelectQuery,
	loader,
	context,
	handleNavigateToReference,
	emptyStateProps,
	showReference,
	showSummarizeResponse,
	referenceThumbnails,
	assistantInfo = defaultAiAssistantInfo,
	isThreadLoading,
	isItemAnswered = true,

	textToSpeach,
	handleShowAllSources,
}: MessagesViewProps) => {
	const { t } = useTranslation();
	const showRecommendedChipsLoading =
		!(loading || streaming) && isRecommendedQuestionsFetching;

	if (isThreadLoading) {
		return (
			<Box flex={1} height="100%" justifyContent="center" alignItems="center">
				<ActivityIndicator size="large" />
			</Box>
		);
	}

	const emptyViewSubtitle = isItemAnswered
		? t("assistant.emptyState.contextSubtitle", { context })
		: t("assistant.emptyState.activateSubtitle", {
				assistantName: assistantInfo.alias,
			});

	return (
		<Box gap={8} height="100%">
			{messages?.length && isItemAnswered ? (
				<ChatList
					assistantInfo={assistantInfo}
					messages={messages}
					loader={loader}
					showRecommendedChipsLoading={showRecommendedChipsLoading}
					recommendedQueries={recommendedQueries}
					handleSelectQuery={handleSelectQuery}
					handleNavigateToReference={handleNavigateToReference}
					showReference={showReference}
					showSummarizeResponse={showSummarizeResponse}
					messageActions={messageActions}
					referenceThumbnails={referenceThumbnails}
					textToSpeach={textToSpeach}
					handleShowAllSources={handleShowAllSources}
				/>
			) : (
				<EmptyView
					title={t("assistant.emptyState.title", {
						assistantName: assistantInfo.alias,
					})}
					subtitle={emptyViewSubtitle}
					image={{ uri: ailaEmptyStateImg }}
					{...emptyStateProps}
				/>
			)}
		</Box>
	);
};
